// "Clear all" button on the cart page — empties the entire cart in a single
// /cart/clear.js call, then reloads so the customer sees the real, correct
// (now-empty) cart straight from the server. Using /cart/clear.js instead of
// removing lines one at a time (or even in a batch) sidesteps the delay
// problem that affected removing a single Goal Plan too — there's no
// iteration at all here, just one request that empties everything, so the
// orphaned-component cleanup reset-cart-plan-guard.js handles elsewhere
// never even has anything left to find.
(function () {
  // The header's own cart-icon component (assets/cart-icon.js) only updates
  // its badge instantly in response to this exact event — a plain page
  // reload doesn't dispatch it at all, so the badge was left showing the
  // stale pre-clear count until the reload's fresh HTML actually finished
  // loading (confirmed live as the reported delay, and the badge could
  // still read correctly from a cache then stay stale until a real manual
  // refresh). Firing it ourselves the moment the server confirms the cart
  // is empty — the same event reset-goal-plan.js's own removePlanBtn
  // handler already uses for the same reason — makes the badge itself
  // correct immediately, independent of how long the page reload takes.
  function notifyCartUpdate(itemCount) {
    try {
      var evt = new Event('shopify:cart:lines-update', { bubbles: true });
      evt.action = 'remove';
      evt.promise = Promise.resolve({ detail: { itemCount: itemCount } });
      document.dispatchEvent(evt);
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reset-cart-clear-all]');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Clearing…';

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        notifyCartUpdate(cart && cart.item_count || 0);
        window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalLabel;
        alert('Could not clear the cart. Please try again.');
      });
  });
})();
